import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "bg-landing-plans pt-10 md:pt-20 relative overflow-hidden"
}
const _hoisted_2 = { class: "max-w-7xl mx-auto relative z-20 md:px-0 px-6" }
const _hoisted_3 = {
  key: 4,
  class: "bg-img2 relative overflow-hidden"
}
const _hoisted_4 = {
  class: "bg-white pb-20 max-w-7xl mx-auto md:px-8 px-6",
  id: "contact"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "text-brand-primary max-w-4xl text-center border-2 border-brand-primary mx-auto"
}
const _hoisted_7 = { class: "max-w-prose mx-auto text-xl text-gray-700 font-gotham-bold text-center py-2" }

import Hero from '../components/content/Hero.vue';
import Hero1 from '../components/content/Hero1.vue';
import Features from '../components/content/Features.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import HelpOptions2 from '../components/content/HelpOptions2.vue';
import PlanSelector from '../components/ordering/PlanSelector.vue';
import PlanSelector2 from '../components/ordering/PlanSelector2.vue';
import Title from '../components/content/Title.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Address, AutocompleteAddressAdapterInterface } from '@/adapters/autocompleteAddressAdapterInterface';
import { Ref, ref } from 'vue';
import { ServiceQualificationAdapterInterface } from '@/adapters/serviceQualificationAdapterInterface';
import store from '@/store';
import router from '@/router';
import { Brand } from '../services/integration/enums';
import { useGtm } from '@gtm-support/vue-gtm';
import HispFeatures from '@/components/content/HispFeatures.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Landing',
  setup(__props) {

const gtm = useGtm();

const autocompleteAddressAdapter = injectStrict<AutocompleteAddressAdapterInterface>('AutocompleteAddressAdapterInterface');
const serviceQualificationAdapter = injectStrict<ServiceQualificationAdapterInterface>('ServiceQualificationAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const featuresData = brandService.getFeaturesData();
const contacts = brandService.getContacts();
const products = brandService.getDefaultPlanSelectorProducts();

// Data.
const address = ref('');
const autocompletedAddresses: Ref<Array<Address>> = ref([]);
const selectedAddress: Ref<Address|undefined> = ref();

// Event handlers.
const unitiRedirect = async () => {
  if (brandService.getName() === Brand.JAM) {
    router.push('/uniti');
  }
};

unitiRedirect();
const handleAddressSearchInputted = async (inputAddress: string) => {
  // When the user types into the address search field, fetch addresses from sq.
  address.value = inputAddress;
  const addresses = await autocompleteAddressAdapter.autocompleteAddress(inputAddress);
  autocompletedAddresses.value = addresses;
};

const handleAutocompletedAddressClicked = (autocompletedAddress: Address) => {
  // When a user clicks an address, set it as the address in the input.
  address.value = autocompletedAddress.address;
  selectedAddress.value = autocompletedAddress;
  autocompletedAddresses.value = [];
};

const handleCheckAddressClicked = async (inputAddress: string, done: () => void) => {
  // When the user submits an address.
  if (selectedAddress.value) {
    // Do SQ.
    const serviceQualification = await serviceQualificationAdapter.serviceQualification(selectedAddress.value);

    if (serviceQualification !== null && serviceQualification?.carrier) {
      console.log('yes', serviceQualification);
      // Save SQ to store.
      store.commit('setServiceQualification', serviceQualification);

      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_ADDRESS_CLICKED',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ ADDRESS SEARCH',
          noninteraction: false,
          state: serviceQualification.state,
          carrier: serviceQualification.carrier
        });
      }

      // Change page.

      if (brandService.getName() === Brand.HIS) {
        router.push('/sign-up-his');
      } else if (brandService.getName() === Brand.NEX) {
        router.push('/sign-up');
      }
    } else {
      console.log('no', serviceQualification);
      if (gtm) {
        gtm.trackEvent({
          event: 'SQ_NOT_SERVICEABLE',
          category: 'SHOPPING',
          action: 'click',
          label: 'SQ NOT SERVICEABLE',
          noninteraction: false
        });
      }
      router.push('/not-serviceable');
    }
  } else {
    done();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(brandService).getName() === _unref(Brand).HIS)
      ? (_openBlock(), _createBlock(Hero, {
          key: 0,
          "autocompleted-addresses": autocompletedAddresses.value,
          address: address.value,
          onOnAutocompletedAddressClicked: handleAutocompletedAddressClicked,
          onOnCheckAddressClicked: handleCheckAddressClicked,
          onOnAddressSearchInputted: handleAddressSearchInputted
        }, null, 8, ["autocompleted-addresses", "address"]))
      : _createCommentVNode("", true),
    (_unref(brandService).getName() === _unref(Brand).NEX)
      ? (_openBlock(), _createBlock(Hero1, {
          key: 1,
          "autocompleted-addresses": autocompletedAddresses.value,
          address: address.value,
          onOnAutocompletedAddressClicked: handleAutocompletedAddressClicked,
          onOnCheckAddressClicked: handleCheckAddressClicked,
          onOnAddressSearchInputted: handleAddressSearchInputted
        }, null, 8, ["autocompleted-addresses", "address"]))
      : _createCommentVNode("", true),
    (_unref(brandService).getName() !== _unref(Brand).HIS)
      ? (_openBlock(), _createBlock(Features, {
          key: 2,
          class: "pt-28",
          features: _unref(featuresData).features,
          header: _unref(featuresData).header,
          id: "features"
        }, null, 8, ["features", "header"]))
      : _createCommentVNode("", true),
    (_unref(brandService).getName() === _unref(Brand).NEX)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"max-w-7xl mx-auto relative z-20 md:px-0 px-6\" id=\"plans\" data-v-67645c91><div class=\"grid grid-cols-1 md:grid-cols-3 z-50\" data-v-67645c91><div class=\"text-left col-start-1 flex flex-col pt-4\" data-v-67645c91><p class=\"text-md text-black font-poppins tracking-widest\" data-v-67645c91>CHOOSE YOUR INTERNET PLAN</p><img class=\"w-1/2 py-2\" src=\"https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/herenowlive.png\" data-v-67645c91><p class=\"text-lg text-black font-poppins tracking-normal\" data-v-67645c91>Powered by Opticomm</p></div><div class=\"text-left col-span-2\" data-v-67645c91><p class=\"text-md text-black font-poppins tracking-normal max-w-sm pt-6\" data-v-67645c91>Browse, stream or game to your heart&#39;s content. Our wide range of internet plans have no data caps. You just need to decide how fast you want to go.</p></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(PlanSelector2, {
              class: "mb-20",
              canSelectProduct: false,
              products: _unref(products),
              selected: ''
            }, null, 8, ["products"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(brandService).getName() === _unref(Brand).NEX)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_unref(brandService).getName() === _unref(Brand).NEX)
        ? (_openBlock(), _createBlock(HelpOptions2, {
            key: 0,
            class: "pb-20",
            features: _unref(contacts)
          }, null, 8, ["features"]))
        : _createCommentVNode("", true),
      (_unref(brandService).getName() === _unref(Brand).HIS)
        ? (_openBlock(), _createBlock(HispFeatures, {
            key: 1,
            class: "pt-20 mb-20",
            features: _unref(featuresData).features,
            header: _unref(featuresData).header,
            id: "features"
          }, null, 8, ["features", "header"]))
        : _createCommentVNode("", true),
      (_unref(brandService).getName() === _unref(Brand).HIS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_unref(brandService).getName() === _unref(Brand).HIS)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_6))
              : _createCommentVNode("", true),
            _createVNode(Title, {
              class: "mt-20",
              title: _unref(brandService).getName() !== _unref(Brand).HIS ? 'Our plans.' : 'Our Internet Plans',
              centered: true,
              id: "plans"
            }, null, 8, ["title"]),
            _withDirectives(_createElementVNode("p", _hoisted_7, " Powered by Opticomm ", 512), [
              [_vShow, _unref(brandService).getName() === _unref(Brand).HIS]
            ]),
            _createVNode(PlanSelector, {
              class: "mt-12 mb-20",
              canSelectProduct: false,
              products: _unref(products),
              selected: ''
            }, null, 8, ["products"])
          ]))
        : _createCommentVNode("", true),
      (_unref(brandService).getName() === _unref(Brand).HIS)
        ? (_openBlock(), _createBlock(Title, {
            key: 3,
            class: "mt-20 mb-4",
            title: "How can we help?",
            centered: true
          }))
        : _createCommentVNode("", true),
      (_unref(brandService).getName() === _unref(Brand).HIS)
        ? (_openBlock(), _createBlock(HelpOptions, {
            key: 4,
            class: "pb-20",
            features: _unref(contacts)
          }, null, 8, ["features"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})